export const getThemeColors = () => {
    return {
        'Achats': 'bg-purple-100 text-purple-700',
        'Assistant(e)': 'bg-pink-100 text-pink-700',
        'Audit - Organisation - Conseil': 'bg-amber-100 text-amber-700',
        'Banque': 'bg-teal-100 text-teal-700',
        'Bureautique - PAO': 'bg-indigo-100 text-indigo-700',
        'Coaching': 'bg-violet-100 text-violet-700',
        'Commercial - Vente': 'bg-orange-100 text-orange-700',
        'Communication': 'bg-rose-100 text-rose-700',
        'Comptabilite - Fiscalité': 'bg-cyan-100 text-cyan-700',
        'Conduite du changement': 'bg-yellow-100 text-yellow-700',
        'Contrôle de gestion': 'bg-sky-100 text-sky-700',
        "Création d'entreprise": 'bg-fuchsia-100 text-fuchsia-700',
        'Digital': 'bg-blue-100 text-blue-700',
        'Direction': 'bg-gray-200 text-gray-800',
        'Droit': 'bg-red-100 text-red-700',
        'Droit des affaires': 'bg-red-100 text-red-700',
        'Developpement personnel': 'bg-green-100 text-green-700',
        'Efficacite professionelle': 'bg-emerald-100 text-emerald-700',
        'Finance - Trésorerie': 'bg-lime-100 text-lime-700',
        'Formation': 'bg-indigo-100 text-indigo-700',
        'Gestion du temps': 'bg-yellow-100 text-yellow-700',
        'Immo & Services généraux': 'bg-stone-100 text-stone-700',
        'Informatique - SI': 'bg-blue-100 text-blue-800',
        'Innovation - Créativité': 'bg-fuchsia-100 text-fuchsia-700',
        'International': 'bg-cyan-100 text-cyan-700',
        'Logistique': 'bg-teal-100 text-teal-700',
        'Management': 'bg-purple-100 text-purple-700',
        'Marketing': 'bg-pink-100 text-pink-700',
        'Organisation - Audit': 'bg-amber-100 text-amber-700',
        'Paie/Admin du personnel': 'bg-indigo-100 text-indigo-700',
        'Production': 'bg-yellow-100 text-yellow-700',
        'Projet': 'bg-sky-100 text-sky-700',
        'Qualité-Santé-Sécurité-Environnement': 'bg-green-100 text-green-700',
        'Relation client': 'bg-orange-100 text-orange-700',
        'Ressources Humaines': 'bg-indigo-100 text-indigo-700',
        'Developpement durable': 'bg-emerald-100 text-emerald-700',
        'Secteur public': 'bg-gray-100 text-gray-700',
        'Soft skills': 'bg-pink-100 text-pink-700',
        'Télétravail (freelance)': 'bg-cyan-100 text-cyan-700',
        'Langue': 'bg-indigo-100 text-indigo-700',
        'Bureautique Microsoft Excel': 'bg-green-100 text-green-700',
        'Bureautique Microsoft Power BI': 'bg-yellow-100 text-yellow-700',
        'Bureautique Microsoft Powerpoint': 'bg-red-100 text-red-700',
        'Bureautique Microsoft Word': 'bg-blue-100 text-blue-700',
        'Bureautique Microsoft Access': 'bg-purple-100 text-purple-700',
        'Art Oratoire': 'bg-rose-100 text-rose-700',
        'Energie et Electricité': 'bg-yellow-100 text-yellow-700',
    };
};

